import { render, staticRenderFns } from "./centerbg.vue?vue&type=template&id=8621e3aa&scoped=true"
import script from "./centerbg.vue?vue&type=script&lang=js"
export * from "./centerbg.vue?vue&type=script&lang=js"
import style0 from "./centerbg.vue?vue&type=style&index=0&id=8621e3aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8621e3aa",
  null
  
)

export default component.exports